// extracted by mini-css-extract-plugin
module.exports = {"bodyMedium":"_2J83kV","bodySmall":"_25DGdy","shortcutButton":"_15CfFq","text":"_3aLIwn","image":"_261Dw6","imageContainer":"wZxtmW","icon":"_20YxDM"};